export const DIALOG_OPEN = 'DIALOG_OPEN'
export const DIALOG_SUBMIT = 'DIALOG_SUBMIT'
export const DIALOG_CANCEL = 'DIALOG_CANCEL'

let id = 0

export function openDialog ({ message, submitMessage, cancelMessage, title } = {}) {
  return {
    type: DIALOG_OPEN,
    id: String(id++),
    message,
    submitMessage,
    cancelMessage,
    title
  }
}

export function submitDialog (id) {
  if (!id) {
    throw new Error('ArgumentException: "id" is required!')
  }
  return {
    type: DIALOG_SUBMIT,
    id
  }
}

export function cancelDialog (id) {
  if (!id) {
    throw new Error('ArgumentException: "id" is required!')
  }
  return {
    type: DIALOG_CANCEL,
    id
  }
}
